<template>
<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 28 28"><path fill="currentColor" d="M7.584 2.333h12.833v4.813h6.417v8.02H1.167v-8.02h6.417zM1.167 16.771h9.625v3.208h6.417v-3.208h9.625v9.625H1.167zM18.011 4.74H9.99v2.406h8.02z"/></svg>
</template>